import Button from "react-bootstrap/Button";
import React from "react";
import { Link } from "react-router-dom";

export const ButtonModalLink = ({
  name,
  link,
  className = "w-50",
  loading = false,
}) => {
  return (
    <Link to={link} className={className}>
      <Button
        variant="outline-offblack"
        disabled={loading}
        className={className}
      >
        {name}
      </Button>
    </Link>
  );
};
